import { apiRequest } from '@/shared/api';

import type {
  AuthResponse,
  SubscriptionStatus,
  UserProfile,
  UserSummary,
} from '../model/types';

/**
 * Вход по initData. Единственный публичный эндпоинт бэкенда:
 * подпись проверяется здесь, дальше всё живёт на JWT.
 */
export function loginWithTelegram(initData: string): Promise<AuthResponse> {
  return apiRequest<AuthResponse>('/auth/telegram', {
    method: 'POST',
    body: { initData },
    anonymous: true,
  });
}

export function fetchMe(): Promise<UserProfile> {
  return apiRequest<UserProfile>('/users/me');
}

/**
 * Профиль и все счётчики игрока одним запросом.
 *
 * Заменяет собой четыре запроса на бутстрапе: Фанкоины, Очки недели,
 * Очки месяца и Фрибеты жили в разных ручках, а шапка видна на каждом
 * экране.
 */
export function fetchMySummary(): Promise<UserSummary> {
  return apiRequest<UserSummary>('/users/me/summary');
}

/**
 * Перепроверить подписку на канал.
 *
 * Статус проверяется при входе, а токен живёт час: игрок, подписавшийся
 * после входа, до этого часами видел «не подписан» — вместе с невыданной
 * Ачивкой. Зовём при возвращении в приложение и только у неподписанных.
 */
export function refreshSubscription(): Promise<SubscriptionStatus> {
  return apiRequest<SubscriptionStatus>('/users/me/subscription/refresh', {
    method: 'POST',
  });
}

export function updateDisplayName(displayName: string): Promise<UserProfile> {
  return apiRequest<UserProfile>('/users/me/display-name', {
    method: 'PATCH',
    body: { displayName },
  });
}
